// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-group, .btn-group-vertical {
  width: 100%;
}

.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle),
.btn-group>.btn:last-child:not(:first-child),
.btn-group>.dropdown-toggle:not(:first-child) {
   border-top-left-radius: 5px;
   border-bottom-left-radius: 5px;
   border-top-right-radius: 5px;
   border-bottom-right-radius: 5px;
}

input[type="checkbox"], input[type="radio"] {
  display:none;
  position: relative !important;
}

.btn, .btn.btn-raised {
  width: 20%;
  min-width: 20%;
  max-width: 30%;
  margin-right: 10px;
}

.btn.btn-raised:not(.btn-link):hover,
.btn:not(.btn-raised):not(.btn-link):hover {
  background-color: #0088cf;
	color: rgba(255,255,255, 0.7);
}

.btn.btn-raised:not(.btn-link).active,
.btn:not(.btn-raised):not(.btn-link).active {
  background-color: #0077B5;
	color: #fff;
  border-radius: 5px;
}

.btn:not(.btn-raised):not(.btn-link).not-editable:hover {
	background: none;
	cursor: default;
}

p.client-informations {
  font-size: 20px;
  font-weight: bold;
  margin-top: 4%;
  color:  #0088cf;
}

/* tab */



/* Nav */
.nav-tabs {
  background: #1985bb !important;
}

.nav li:first-child {
  margin-left: 6px;
}

.nav li {
  margin-top: 6px;
  margin-right: 6px;
}

.nav-tabs > li > a {
  border-radius: 5px;
}

.nav-tabs > li > a:hover {
  background-color: #69b4d9 !important;
  border: 0;
}

.nav-tabs > li > a:focus,
.nav-tabs > li.active > a {
  background-color: #11587b !important;
}

/* Small devices (tablets, 768px and up) */
@media (max-width: 768px) {
  .btn.btn-raised {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/Components/TSCheck/tscheck.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;;;GAGG,2BAA2B;GAC3B,8BAA8B;GAC9B,4BAA4B;GAC5B,+BAA+B;AAClC;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;CAC1B,6BAA6B;AAC9B;;AAEA;;EAEE,yBAAyB;CAC1B,WAAW;EACV,kBAAkB;AACpB;;AAEA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,QAAQ;;;;AAIR,QAAQ;AACR;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,SAAS;AACX;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,0CAA0C;AAC1C;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".btn-group, .btn-group-vertical {\n  width: 100%;\n}\n\n.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle),\n.btn-group>.btn:last-child:not(:first-child),\n.btn-group>.dropdown-toggle:not(:first-child) {\n   border-top-left-radius: 5px;\n   border-bottom-left-radius: 5px;\n   border-top-right-radius: 5px;\n   border-bottom-right-radius: 5px;\n}\n\ninput[type=\"checkbox\"], input[type=\"radio\"] {\n  display:none;\n  position: relative !important;\n}\n\n.btn, .btn.btn-raised {\n  width: 20%;\n  min-width: 20%;\n  max-width: 30%;\n  margin-right: 10px;\n}\n\n.btn.btn-raised:not(.btn-link):hover,\n.btn:not(.btn-raised):not(.btn-link):hover {\n  background-color: #0088cf;\n\tcolor: rgba(255,255,255, 0.7);\n}\n\n.btn.btn-raised:not(.btn-link).active,\n.btn:not(.btn-raised):not(.btn-link).active {\n  background-color: #0077B5;\n\tcolor: #fff;\n  border-radius: 5px;\n}\n\n.btn:not(.btn-raised):not(.btn-link).not-editable:hover {\n\tbackground: none;\n\tcursor: default;\n}\n\np.client-informations {\n  font-size: 20px;\n  font-weight: bold;\n  margin-top: 4%;\n  color:  #0088cf;\n}\n\n/* tab */\n\n\n\n/* Nav */\n.nav-tabs {\n  background: #1985bb !important;\n}\n\n.nav li:first-child {\n  margin-left: 6px;\n}\n\n.nav li {\n  margin-top: 6px;\n  margin-right: 6px;\n}\n\n.nav-tabs > li > a {\n  border-radius: 5px;\n}\n\n.nav-tabs > li > a:hover {\n  background-color: #69b4d9 !important;\n  border: 0;\n}\n\n.nav-tabs > li > a:focus,\n.nav-tabs > li.active > a {\n  background-color: #11587b !important;\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (max-width: 768px) {\n  .btn.btn-raised {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
